import {makeStyles} from "@material-ui/styles";

export default makeStyles(theme => ({
    root: {
        display: "flex",
        maxWidth: "100vw",
        overflowX: "hidden",
    },
    content: {
        flexGrow: 1,
        paddingTop: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingBottom: theme.spacing(1),
        width: `calc(100vw - 240px)`,
        minHeight: "100vh",
        flexDirection: 'column',
    },
    contentShift: {
        width: `calc(100vw - ${240 + theme.spacing(6)}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    fakeToolbar: {
        ...theme.mixins.toolbar,
    },
    link: {
        '&:not(:first-child)': {
            paddingLeft: 15
        }
    },
    subContent: {
        minHeight: "75vh",
    },
    footer: {
        // flexGrow: 1,
        // padding: theme.spacing(3),
        bottom: "0",
        // minHeight:"5vh"
    },
    footerButtons: {
        color: theme.palette.text.main
    },
    footerContainer: {
        // padding: theme.spacing(5),

        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(0)
        },
    }
}), {index: 1});